module.exports = __webpack_public_path__ + "static/media/adgroup.64122635.svg";